<template>
    <div id="ui-test-view"
         class="full-vue-page">
        <div>
            <h1>This is a heading 1</h1>
            <h2>This is a heading 2</h2>
            <h3>This is a heading 3</h3>
            <h4>This is a heading 4</h4>
            <h5>This is a heading 5</h5>
            <h6>This is a heading 6</h6>
            <p>
                This is a paragraph. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec
                vehicula, enim nec facilisis efficitur, ligula nunc facilisis nisi, nec tincidunt
                ligula nunc non nisi.
            </p>
        </div>

        <div>
            <div v-for="state in alertStates"
                 :key="state"
                 :class="`alert alert-${state}`">
                This is a {{ state }} alert.
            </div>
        </div>

        <div class="transparent">
            <div class="alert alert-warning alert-warning--adaptive">
                This is a warning alert that adapts to the background (dark on desktop, light on mobile).
            </div>
        </div>

        <div>
            <h2>Alert (Vue)</h2>
            <div class="btns">
                <a class="btn btn-info"
                   @click="showAlertModal('single')">
                    Single Text
                </a>
                <a class="btn btn-info"
                   @click="showAlertModal('multiple')">
                    Multiple Text
                </a>
                <a class="btn btn-info"
                   @click="showAlertModal('custom-text')">
                    Custom Text
                </a>
                <a class="btn btn-info"
                   @click="showAlertModal('custom-html')">
                    Custom HTML
                </a>
                <a class="btn btn-info"
                   @click="showAlertModal('all')">
                    All
                </a>
            </div>

            <div class="btns mt-1">
                <a class="btn btn-danger"
                   @click="showColoredAlertModal('danger', 'fa-triangle-exclamation')">
                    Danger
                </a>
                <a class="btn btn-warning"
                   @click="showColoredAlertModal('warning', 'fa-circle-exclamation')">
                    Warning
                </a>
                <a class="btn btn-success"
                   @click="showColoredAlertModal('success', 'fa-circle-check')">
                    Success
                </a>
            </div>
        </div>

        <div>
            <h2>Confirm (Vue)</h2>
            <div class="btns">
                <a class="btn btn-info"
                   @click="showVueConfirmModal('single')">
                    Single Text
                </a>
                <a class="btn btn-info"
                   @click="showVueConfirmModal('multiple')">
                    Multiple Text
                </a>
                <a class="btn btn-info"
                   @click="showVueConfirmModal('custom-text')">
                    Custom Text
                </a>
                <a class="btn btn-info"
                   @click="showVueConfirmModal('custom-html')">
                    Custom HTML
                </a>
                <a class="btn btn-info"
                   @click="showVueConfirmModal('all')">
                    All
                </a>

                <a class="btn btn-info"
                   @click="showCustomConfirmDialog()">
                    Custom Buttons
                </a>

                <a class="btn btn-info"
                   @click="showCustomConfirmDialog2()">
                    Custom Buttons 2
                </a>
            </div>
        </div>

        <div>
            <h2>Prompt (Vue)</h2>
            <div class="btns">
                <a class="btn btn-info"
                   @click="showPromptModal()">
                    Default
                </a>
                <a class="btn btn-info"
                   @click="showPromptModalCustom()">
                    Custom
                </a>
            </div>
        </div>

        <div>
            <h2>Num Pad</h2>
            <div class="btns">
                <a class="btn btn-info"
                   @click="showNumPadModal()">
                    Show Num Pad
                </a>

                <a class="btn btn-info"
                   @click="showNumPadModal('minimal')">
                    Show Minimal Num Pad
                </a>

                <a class="btn btn-info"
                   @click="showNumPadModal('all')">
                    Show Vue Num Pad WIth Options
                </a>
            </div>
        </div>

        <div>
            <h2>Toast</h2>
            <div class="btns">
                <a class="btn btn-success"
                   @click="showTestToast('success')">
                    Success
                </a>

                <a class="btn btn-info"
                   @click="showTestToast('info')">
                    Info
                </a>

                <a class="btn btn-danger"
                   @click="showTestToast('error')">
                    Error
                </a>

                <a class="btn btn-warning"
                   @click="showTestToast('warning')">
                    Warning
                </a>

                <a class="btn btn-default"
                   @click="showTestSpinnerToast()">
                    Spinner
                </a>

                <a class="btn btn-default"
                   @click="showTestToastWithButton()">
                    Button
                </a>
            </div>

            <div class="btns mt-1">
                <a class="btn btn-success"
                   @click="showTestToastTop('success')">
                    Success Top
                </a>

                <a class="btn btn-info"
                   @click="showTestToastTop('info')">
                    Info Top
                </a>

                <a class="btn btn-danger"
                   @click="showTestToastTop('error')">
                    Error Top
                </a>

                <a class="btn btn-warning"
                   @click="showTestToastTop('warning')">
                    Warning Top
                </a>
            </div>
        </div>

        <div>
            <h2>Customer Screen</h2>
            <div class="btns">
                <a class="btn btn-info"
                   @click="askTestBooleanQuestion()">
                    Ask Boolean Question
                </a>

                <a class="btn btn-info"
                   @click="askTestOptionsQuestion()">
                    Ask Options Question
                </a>
            </div>

            <div class="btns mt-1">
                <a class="btn btn-info"
                   @click="showCustomerScreenQRCode()">
                    Show QR Code
                </a>

                <a class="btn btn-info"
                   @click="cancelCustomerScreenQRCode()">
                    Cancel QR Code
                </a>
            </div>
        </div>

        <div>
            <h2>Modals</h2>
            <div class="btns">
                <a class="btn btn-info"
                   @click="showAddressModal()">
                    Address
                </a>

                <a class="btn btn-info"
                   @click="showAdjustFloatModal()">
                    Adjust Float
                </a>

                <a class="btn btn-info"
                   @click="showPhotoSelectorModal()">
                    Photo Selector
                </a>
            </div>
        </div>

        <div>
            <h2>Buttons</h2>

            <table class="table table--no-border">
                <tr v-for="state in defaultStates"
                    :key="state">
                    <td>
                        <button class="btn btn-sm"
                                :class="`btn-${state}`">
                            Small {{ ucfirstFilter(state) }} Button
                        </button>
                    </td>
                    <td>
                        <button class="btn"
                                :class="`btn-${state}`">
                            {{ ucfirstFilter(state) }} Button
                        </button>
                    </td>
                    <td>
                        <button class="btn btn-lg"
                                :class="`btn-${state}`">
                            Large {{ ucfirstFilter(state) }} Button
                        </button>
                    </td>
                    <td>
                        <button class="btn btn-xl"
                                :class="`btn-${state}`">
                            Extra Large {{ ucfirstFilter(state) }} Button
                        </button>
                    </td>
                </tr>

                <!-- All button colours look the same when disabled. -->
                <tr>
                    <td>
                        <button class="btn btn-sm btn-default"
                                disabled>
                            Small Disabled Button
                        </button>
                    </td>
                    <td>
                        <button class="btn btn-default"
                                disabled>
                            Disabled Button
                        </button>
                    </td>
                    <td>
                        <button class="btn btn-lg btn-default"
                                disabled>
                            Large Disabled Button
                        </button>
                    </td>
                    <td>
                        <button class="btn btn-xl btn-default"
                                disabled>
                            Extra Large Disabled Button
                        </button>
                    </td>
                </tr>

                <!-- A <small> subtitle grows the button to fit it, whatever size the button is. -->
                <tr>
                    <td>
                        <button class="btn btn-sm btn-info">
                            Small Button
                            <small>With a subtitle</small>
                        </button>
                    </td>
                    <td>
                        <button class="btn btn-info">
                            Button
                            <small>With a subtitle</small>
                        </button>
                    </td>
                    <td>
                        <button class="btn btn-lg btn-info">
                            Large Button
                            <small>With a subtitle</small>
                        </button>
                    </td>
                    <td>
                        <button class="btn btn-xl btn-info">
                            Extra Large Button
                            <small>
                                <i class="fa-solid fa-triangle-exclamation"></i>
                                With a subtitle and an icon
                            </small>
                        </button>
                    </td>
                </tr>
            </table>
        </div>

        <div>
            <h2>Labels</h2>

            <table class="table table--no-border">
                <tr v-for="state in labelStates"
                    :key="state">
                    <td>&nbsp;</td>
                    <td>
                        <span class="label"
                              :class="`label-${state}`">{{ ucfirstFilter(state) }} Label</span>
                    </td>
                    <td>
                        <span class="label label-lg"
                              :class="`label-${state}`">Large {{ ucfirstFilter(state) }} Label</span>
                    </td>
                </tr>
            </table>
        </div>

        <div>
            <h2>Indicators</h2>

            <table class="table table--no-border">
                <tr v-for="state in defaultStates"
                    :key="state">
                    <td>
                        <span class="indicator indicator-sm"
                              :class="`indicator-${state}`">Small {{ ucfirstFilter(state) }} Indicator</span>
                    </td>
                    <td>
                        <span class="indicator"
                              :class="`indicator-${state}`">{{ ucfirstFilter(state) }} Indicator</span>
                    </td>
                    <td>&nbsp;</td>
                </tr>
            </table>

            <div>
                <span class="indicator indicator-primary">Block Indicator</span>
            </div>
        </div>

        <div>
            <h2>Example Indicators</h2>

            <div class="pa-1">
                <span class="indicator indicator-success">Paid In Full</span>
                <a class="btn btn-info">Payments</a>
            </div>

            <div class="pa-1">
                <span class="indicator-btn-group indicator-btn-group-inline">
                    <span class="indicator indicator-success">Paid In Full</span>
                    <a class="btn btn-info">Payments</a>
                </span>

                &nbsp;

                <span class="indicator-btn-group indicator-btn-group-inline">
                    <span class="indicator indicator-warning">Partially Paid</span>
                    <a class="btn btn-info">Payments</a>
                </span>

                &nbsp;

                <span class="indicator-btn-group indicator-btn-group-inline">
                    <span class="indicator indicator-danger">Unpaid</span>
                    <a class="btn btn-info">Payments</a>
                </span>
            </div>
        </div>

        <div class="dark">
            <h2>Indicators on Dark</h2>

            <div style="padding: 15px;">
                <h4>Default</h4>
                <span class="indicator">Indicator</span>
                <span class="indicator indicator-danger">Success Indicator</span>
                <span class="indicator indicator-info">Info Indicator</span>
                <span class="indicator indicator-success">Success Indicator</span>
                <span class="indicator indicator-warning">Warning Indicator</span>
                <span class="indicator indicator-primary">Primary Indicator</span>
            </div>

            <div style="padding: 15px;">
                <h4>.indicator-white</h4>
                <span class="indicator indicator-white">Indicator</span>
                <span class="indicator indicator-white indicator-danger">Success Indicator</span>
                <span class="indicator indicator-white indicator-info">Info Indicator</span>
                <span class="indicator indicator-white indicator-success">Success Indicator</span>
                <span class="indicator indicator-white indicator-warning">Warning Indicator</span>
                <span class="indicator indicator-white indicator-primary">Primary Indicator</span>
            </div>
        </div>

        <div>
            <h2>Toggle</h2>

            <div class="toggle toggle--label-before toggle--non-bold">
                <input id="toggle1"
                       type="checkbox"
                       name="toggle1" />
                <label for="toggle1">This is a toggle with the label before the slider</label>
            </div>

            <div class="toggle toggle--label-after toggle--non-bold">
                <input id="toggle2"
                       type="checkbox"
                       name="toggle2" />
                <label for="toggle2">This is a toggle with the label after the slider</label>
            </div>
        </div>

        <div>
            <h2>MultiSelect</h2>
            <UiTestMultiSelect />
        </div>

        <div>
            <h2>.form-h</h2>
            <UiTestForm class="form-h"></UiTestForm>
        </div>

        <div>
            <h2>.form-v</h2>
            <UiTestForm class="form-v"></UiTestForm>
        </div>

        <div>
            <h2>.btn-list</h2>
            <div class="btn-list">
                <button v-for="btn in btnListBtns"
                        :key="btn.label"
                        class="btn btn-lg btn-block btn-white">
                    <strong class="break-wrap">{{ btn.label }}</strong>
                    <small v-if="btn.description1">{{ btn.description1 }}</small>
                    <small v-if="btn.description2">{{ btn.description2 }}</small>
                </button>
            </div>
        </div>

        <div>
            <h2>.btn-list.selectable-btns</h2>
            <div class="btn-list selectable-btns">
                <button v-for="btn in selectableBtnListBtns"
                        :key="btn.label"
                        class="btn btn-lg btn-block btn-white"
                        :class="{active: btn.active}"
                        @click.prevent="selectableBtnListBtns.forEach((b) => b.active = false); btn.active=true;">
                    <strong class="break-wrap">{{ btn.label }}</strong>
                    <small v-if="btn.description1">{{ btn.description1 }}</small>
                    <small v-if="btn.description2">{{ btn.description2 }}</small>
                </button>
            </div>
        </div>

        <div>
            <h2>TodayBadge</h2>

            <table class="table table--no-border text-left">
                <tr>
                    <td>Today</td>
                    <td>
                        {{ dateFilter(todayDate) }}
                        <TodayBadge :date="todayDate" />
                    </td>
                </tr>
                <tr>
                    <td>Tomorrow</td>
                    <td>
                        {{ dateFilter(tomorrowDate) }}
                        <TodayBadge :date="tomorrowDate" />
                    </td>
                </tr>
                <tr>
                    <td>Past Date</td>
                    <td>
                        {{ dateFilter(pastDate) }}
                        <TodayBadge :date="pastDate" />
                    </td>
                </tr>
                <tr>
                    <td>Today (with show not today)</td>
                    <td>
                        {{ dateFilter(todayDate) }}
                        <TodayBadge :date="todayDate"
                                    show-not-today />
                    </td>
                </tr>
                <tr>
                    <td>Tomorrow (with show not today)</td>
                    <td>
                        {{ dateFilter(tomorrowDate) }}
                        <TodayBadge :date="tomorrowDate"
                                    show-not-today />
                    </td>
                </tr>
                <tr>
                    <td>Past Date (with show not today)</td>
                    <td>
                        {{ dateFilter(pastDate) }}
                        <TodayBadge :date="pastDate"
                                    show-not-today />
                    </td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
import CustomerScreenQRCodeData from '@/lib/CustomerScreen/CustomerScreenQRCodeData';
import CustomerScreenQuestion from '@/lib/CustomerScreen/CustomerScreenQuestion';
import CustomerScreenQuestionType from '@/lib/CustomerScreen/CustomerScreenQuestionType';
import TodayBadge from '@/epos/vue/components/Badges/TodayBadge';
import UiTestForm from '@/epos/vue/pages/ui-test/UiTestForm';
import UiTestMultiSelect from '@/epos/vue/pages/ui-test/UiTestMultiSelect';
import { container } from '@/container';
import { dateFilter } from '@/vue/filters/dateFilter';
import { getTodayMidnightDate, getTomorrowMidnightDate, toHMS } from '@/functions/date';
import { MODAL_NAMES } from '@/vue/modals/MODAL_NAMES';
import { MODAL_NAMES__EPOS } from '@/epos/vue/modals/MODAL_NAMES__EPOS';

export default {
    components: {
        TodayBadge,
        UiTestForm,
        UiTestMultiSelect,
    },

    data() {
        return {
            todayDate: getTodayMidnightDate(),
            tomorrowDate: getTomorrowMidnightDate(),
            pastDate: new Date('1990-05-20'),

            defaultStates: [
                'default',
                'primary',
                'info',
                'success',
                'danger',
                'warning',
                'white',
            ],

            alertStates: [
                'info',
                'success',
                'danger',
                'warning',
            ],

            labelStates: [
                'default',
                'neutral',
                'primary',
                'info',
                'success',
                'danger',
                'warning',
                'cancelled',
            ],

            btnListBtns: [
                {
                    label: 'Alice Alisson',
                    description1: 'Customer since 2015',
                },
                {
                    label: 'Bob Boberson',
                    description1: 'Customer since 2018',
                    description2: "He's a pretty cool guy.",
                },
                {
                    label: 'Charlie Charlson',
                    description1: 'Customer since 2020',
                },
            ],

            selectableBtnListBtns: [
                {
                    label: 'Alice Alisson',
                    description1: 'Customer since 2015',
                },
                {
                    label: 'Bob Boberson',
                    description1: 'Customer since 2018',
                    description2: "He's a pretty cool guy.",
                    active: true,
                },
                {
                    label: 'Charlie Charlson',
                    description1: 'Customer since 2020',
                },
            ],
        };
    },

    methods: {
        dateFilter,

        showAlertModal(type) {
            let promise;

            switch (type) {
                case 'single':
                    promise = container.dialogService.alert('UI_TEST.EXAMPLE_STRING');
                    break;
                case 'multiple':
                    promise = container.dialogService.alert(['UI_TEST.EXAMPLE_STRING', 'PLEASE_WAIT', 'SEARCHING']);
                    break;
                case 'custom-text':
                    promise = container.dialogService.alert(
                        '',
                        {
                            customText: 'Lorem ipsum dolor sit amet. Any HTML in customText is escaped<br/><b>because</b> it could be displaying text from unknown sources like an API response.',
                        },
                    );
                    break;
                case 'custom-html':
                    promise = container.dialogService.alert(
                        '',
                        {
                            customHtml: 'Using customHtml <u>does</u> <b>allow</b> HTML.',
                        },
                    );
                    break;
                case 'all':
                    promise = container.dialogService.alert(
                        ['UI_TEST.EXAMPLE_STRING', 'PLEASE_WAIT', 'SEARCHING'],
                        {
                            icon: 'fa-bahai',
                            customTitleText: 'Hello, world!',
                            customText: 'Custom <b>text</b>.',
                            customHtml: 'Custom <b>html</b>.',
                        },
                    );
                    break;
            }

            promise
                .then(() => {
                    alert('Alert promise resolved.');
                })
                .catch(() => {
                    // This shouldn't be possible.
                    alert('Alert promise rejected.');
                });
        },

        showColoredAlertModal(color, icon) {
            container.dialogService.alert(
                'UI_TEST.EXAMPLE_STRING',
                {
                    color,
                    icon,
                    customTitleText: `This is a ${color} alert`,
                },
            );
        },

        showVueConfirmModal(type) {
            let promise;

            switch (type) {
                case 'single':
                    promise = container.dialogService.confirm(
                        'UI_TEST.EXAMPLE_STRING',
                        { title: 'CONFIRM' },
                    );
                    break;
                case 'multiple':
                    promise = container.dialogService.confirm(
                        ['UI_TEST.EXAMPLE_STRING', 'PLEASE_WAIT', 'SEARCHING'],
                    );
                    break;
                case 'custom-text':
                    promise = container.dialogService.confirm(
                        null,
                        {
                            customText: 'Lorem ipsum dolor sit amet. Any HTML in customText is escaped<br/><b>because</b> it could be displaying text from unknown sources like an API response.',
                        },
                    );
                    break;
                case 'custom-html':
                    promise = container.dialogService.confirm(
                        null,
                        {
                            customHtml: 'Using customHtml <u>does</u> <b>allow</b> HTML.',
                        },
                    );
                    break;
                case 'all':
                    promise = container.dialogService.confirm(
                        ['UI_TEST.EXAMPLE_STRING', 'PLEASE_WAIT', 'SEARCHING'],
                        {
                            icon: 'fa-bahai',
                            customTitleText: 'This is custom title text',
                            customText: 'Custom <b>text</b>.',
                            customHtml: 'Custom <b>html</b>.',
                            cancelLabel: 'EDIT',
                            okLabel: 'RETRY',
                        },
                    );
                    break;
            }

            promise.then((result) => console.log('Confirm resolved.', result))
                .catch((err) => console.log('Confirm rejected.', err));
        },

        showCustomConfirmDialog() {
            const promise = container.dialogService.customConfirm(
                ['UI_TEST.EXAMPLE_STRING', 'PLEASE_WAIT', 'SEARCHING'],
                [
                    {
                        label: 'RETRY',
                        color: 'info',
                        value: 'retry it.',
                    },
                    {
                        label: 'ADD',
                        color: 'success',
                        value: 'add it!',
                    },
                ],
            );

            promise.then((result) => console.log('Confirm resolved.', result))
                .catch((err) => console.log('Confirm rejected.', err));
        },

        showCustomConfirmDialog2() {
            container.dialogService
                .customConfirm(
                    '',
                    [
                        {
                            label: 'PAYMENT_WORLDPAY.RECOVERED_TXN_WAIT_BTN',
                            color: 'warning',
                            value: 'wait',
                        },
                        {
                            label: 'PAYMENT_WORLDPAY.RECOVERED_TXN_YES_BTN',
                            color: 'success',
                            value: 'yes',
                        },
                    ],
                    {
                        cancelLabel: 'PAYMENT_WORLDPAY.RECOVERED_TXN_NO_BTN',
                        cancelColor: 'danger',
                        customText: container.$filter('lang')(
                            'PAYMENT_WORLDPAY.RECOVERED_TXN_MESSAGE',
                            {
                                amount: 12.34,
                            },
                        ),
                    },
                )
                .then((value) => {
                    switch (value) {
                        case 'yes':
                            window.alert('Yes');
                            break;
                    }
                })
                .catch(() => {
                });
        },

        showPromptModal() {
            container.dialogService
                .prompt(
                    ['UI_TEST.EXAMPLE_STRING', 'PLEASE_WAIT', 'SEARCHING'],
                )
                .then((result) => {
                    console.log('result', result);
                });
        },

        showPromptModalCustom() {
            container.dialogService
                .prompt(
                    'UI_TEST.EXAMPLE_STRING',
                    {
                        title: 'SEARCH',
                        customInputs: {
                            amount: {
                                value: 123.45,
                                label: 'PAYMENT.MANUAL_RECONCILIATION_AMOUNT',
                            },
                        },
                        keyUp(value) {
                            return value.toUpperCase();
                        },
                        customBtns: [
                            {
                                label: 'PAYMENT.REPRINT_BTN',
                                handler(modal) {
                                    console.log('reprint button pressed', modal);
                                    modal.reject();
                                },
                            },
                        ],
                        minLength: 3,
                        maxLength: 10,
                        regex: new RegExp(/^[A-Z]+$/),
                        defaultValue: 'ab',
                    },
                )
                .then((result) => {
                    console.log('result', result);
                });
        },

        showNumPadModal(type) {
            let props;

            switch (type) {
                case 'all':
                    props = {
                        initialValue: 12.34,
                        customTitleText: 'Custom title!',
                        icon: 'fa-solid fa-alien-8bit',
                        displayAsCurrency: true,
                        okColor: 'warning',
                        okCustomText: 'Do It',
                        cancelLabel: 'RESTORE',
                        cancelColor: 'info',
                        customHtml: '<strong>This</strong> is a demo of some custom text in the modal.',
                        min: 1,
                        max: 100,
                        numPadOptions: {
                            showCashButtons: true,
                            showSignButton: false,
                        },
                        customInputs: {
                            name: {
                                label: 'NAME',
                                placeholder: 'GIFT_VOUCHERS.RECIPIENT_NAME_REQUIRED_ERROR',
                            },
                        },
                    };
                    break;

                case 'minimal':
                    props = {
                        numPadOptions: {
                            showBackspaceButton: false,
                            showClearButton: false,
                            showSignButton: false,
                            showDecimalButton: false,
                        },
                    };
                    break;

                default:
                    props = {
                        initialValue: 12.34,
                        title: 'ADJUST_FLOAT.ADD_CASH_TO_TILL',
                        icon: 'fa-solid fa-alien-8bit',
                        displayAsCurrency: true,
                        min: 1,
                        max: 100,
                        numPadOptions: {
                            showCashButtons: true,
                            showSignButton: false,
                        },
                    };
                    break;
            }

            container.vueModalFactory
                .open(
                    MODAL_NAMES.NUM_PAD,
                    props,
                )
                .then((result) => {
                    console.log(result);
                })
                .catch((err) => {
                    console.error(err);
                });
        },

        showTestToast(style) {
            container.toastFactory[style]('ABOUT.TEST', toHMS(new Date()));
        },

        showTestToastTop(style) {
            container.toastFactory[style + 'Top']('ABOUT.TEST', toHMS(new Date()));
        },

        showTestSpinnerToast() {
            let p = new Promise((resolve) => {
                setTimeout(resolve, 3000);
            });

            container.toastFactory.spinner(
                'PROCESSING',
                'This will disappear in 3 seconds.',
                p,
                null,
            );
        },

        showTestToastWithButton() {
            container.toastFactory.info(
                'ABOUT.TEST',
                'Click me anywhere to trigger an action. <button class="btn btn-default btn-sm">With a Button</button>',
                {
                    timeOut: 5000,
                    extendedTimeOut: 5000,
                    onclick: () => {
                        window.alert('You clicked it.');
                    },
                },
            );
        },

        askTestBooleanQuestion() {
            let question = new CustomerScreenQuestion(
                CustomerScreenQuestionType.BOOLEAN,
                'Does <em>this</em> work?',
            );

            container.customerScreenDataService
                .askQuestion(question)
                .then((res) => {
                    window.alert('Answer was ' + (res ? 'yes' : 'no'));
                })
                .catch((res) => {
                    console.log('Rejected', res);
                });
        },

        askTestOptionsQuestion() {
            let question = new CustomerScreenQuestion(
                CustomerScreenQuestionType.OPTIONS,
                'Which is the best animal at ' + toHMS(new Date()) + '?',
                [
                    {
                        value: 'dogs',
                        label: 'Dogs',
                    },
                    {
                        value: 'cats',
                        label: 'Cats',
                    },
                    {
                        value: 'rabbits',
                        label: 'Rabbits',
                    },
                ],
            );

            container.customerScreenDataService
                .askQuestion(question)
                .then((res) => {
                    window.alert('Selected option value was ' + res);
                })
                .catch((res) => {
                    console.log('Rejected', res);
                });
        },

        showCustomerScreenQRCode() {
            container.customerScreenDataService.showQRCode(
                new CustomerScreenQRCodeData({
                    content: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ',
                    title: 'Scan This Code To Access The <em>Information</em>',
                }),
            );
        },

        cancelCustomerScreenQRCode() {
            container.customerScreenDataService.hideQRCode();
        },

        showAddressModal() {
            container.vueModalFactory
                .open(
                    MODAL_NAMES__EPOS.ADDRESS,
                    {
                        title: 'ADDRESS.ADDRESS',
                        address: {},
                    },
                )
                .then((res) => {
                    console.log('res', res);
                })
                .catch((err) => {
                    console.log('err', err);
                });
        },

        showPhotoSelectorModal() {
            container.vueModalFactory
                .open(MODAL_NAMES.PHOTO_SELECTOR)
                .then((res) => {
                    console.log('res', res);
                })
                .catch((err) => {
                    console.log('err', err);
                });
        },

        showAdjustFloatModal() {
            container.vueModalFactory
                .open(
                    MODAL_NAMES__EPOS.ADJUST_FLOAT,
                    {
                        mode: 'add',
                    },
                )
                .then((res) => {
                    console.log('res', res);
                })
                .catch((err) => {
                    console.log('err', err);
                });
        },
    },
};
</script>

<style lang="less">
@import (reference) "../../../../less/variables";

#ui-test-view {
    padding-bottom: 1px;

    > div {
        margin: 15px;
        padding: 15px;
        text-align: center;
        border-radius: @border-radius-base;
        border: 1px transparent solid;

        &:not(.transparent) {
            &:not(.dark) {
                background: @white;
            }

            &.dark {
                border-color: rgba(255, 255, 255, .2);

                &,
                h3,
                h4 {
                    color: @white;
                }
            }
        }
    }

    .table {
        td {
            width: 33%;
            vertical-align: middle;
            padding: 5px;
        }
    }
}
</style>
